import http from './http'
const warehouseApi = '/Address'
const scinApi = '/Scin'

function getAddressDropdown() {
  return http.get(`${warehouseApi}/getAddress`)
}

function getImporterPages(params) {
  return http.post(`${warehouseApi}/getImporterPages`, params)
}
function getScinPageList(params) {
  return http.post(`${scinApi}/getScinPageList`, params)
}

function defaultAddressBook(params) {
  return http.post(`${warehouseApi}/defaultAddressBook`, params)
}
function saveScin(params) {
  return http.post(`${scinApi}/saveScin`, params)
}
function getScinList(params) {
  return http.get(`${scinApi}/getScinList`, params)
}

function getAddressBookDrapdown(params) {
  return http.get(`${warehouseApi}/getAddressBookDrapdown`, params)
}
function getAddressFill(params) {
  return http.get(`${warehouseApi}/getAddressFill`, params)
}
function deleteAddressBook(params) {
  return http.delete(`${warehouseApi}/deleteAddressBook`, params)
}
function deleteScin(params) {
  return http.delete(`${scinApi}/deleteScin`, params)
}
function addressBookCompanyList(params) {
  return http.get(`${warehouseApi}/addressBookCompanyList`, params)
}
function distributeAddressBook(params) {
  return http.post(`${warehouseApi}/distributeAddressBook`, params)
}
function updateImporterAdvance(params) {
  return http.post(`${warehouseApi}/updateImporterAdvance`, params)
}
function getImporterFiles(params) {
  return http.get(`${warehouseApi}/getImporterFiles`, params)
}
function openSearchAddressBooks(params) {
  return http.post(`${warehouseApi}/openSearchAddressBooks`, params)
}
function openDeleteAddressBook(params) {
  return http.delete(`${warehouseApi}/openDeleteAddressBook`, params)
}
function getAddressBookPages(params) {
  return http.post(`${warehouseApi}/getAddressBookPages`, params)
}
function saveAddressBook(params) {
  return http.post(`${warehouseApi}/saveAddressBook`, params)
}

function uploadImporterFile(params, formData, fn) {
  params = Object.keys(params).map(a => `${a}=${params[a]}`).join('&')
  return http.upload(`${warehouseApi}/uploadImporterFile?${params}`, formData, fn)
}

const TaxRate = '/TaxRate'
function deleteTaxRate(params) {
  return http.delete(`${TaxRate}/deleteTaxRate`, params)
}
function getTaxRatePage(params) {
  return http.post(`${TaxRate}/getTaxRatePageList`, params)
}
function saveTaxRate(params) {
  return http.post(`${TaxRate}/saveTaxRate`, params)
}

const TaxProduct = '/TaxProduct'
function getTaxProductPage(params) {
  return http.post(`${TaxProduct}/getTaxProductPage`, params)
}
function saveTaxProduct(params) {
  return http.post(`${TaxProduct}/saveTaxProduct`, params)
}
function deleteTaxProduct(params) {
  return http.delete(`${TaxProduct}/deleteTaxProduct`, params)
}

function copyPrivateProductToPublic(params) {
  return http.get(`${TaxProduct}/copyPrivateProductToPublic`, params)
}

function getTaxRateList(params) {
  return http.post(`${TaxProduct}/getTaxRateList`, params)
}
function saveImportTaxProduct(params) {
  return http.post(`${TaxProduct}/saveImportTaxProduct`, params)
}
function searchUSHts(params) {
  return http.get(`${TaxProduct}/searchUSHts`, params)
}
function tagTaxProduct(params) {
  return http.get(`${TaxProduct}/tagTaxProduct`, params)
}
function confirmTaxProduct(params) {
  return http.post(`${TaxProduct}/confirmTaxProduct`, params)
}

const Track = '/MBLTrack'
function trackEvents(params) {
  return http.get(`${Track}/trackEvents`, params)
}
function isfEvents(params) {
  return http.get(`${Track}/isfEvents`, params)
}
function abiquery(params) {
  return http.get(`${Track}/abiquery`, params)
}
function catchContainerEvents(params) {
  return http.get(`${Track}/catchContainerEvents`, params)
}
function eFreightContainerEvents(params) {
  return http.get(`${Track}/eFreightContainerEvents`, params)
}

function manualRefreshContainerEvents(params) {
  return http.get(`${Track}/manualRefreshContainerEvents`, params)
}
function AMSQuery(params, update) {
  return http.post(`${Track}/AMSQuery${update ? '?update=true' : ''}`, params)
}
function iTraceTerminal(params) {
  return http.get(`${Track}/iTraceTerminal`, params)
}
function reSubscribeClearanceTrack(params) {
  return http.get(`${Track}/reSubscribeClearanceTrack`, params)
}

const Harbor = '/Harbor'
function harborDrapDown(params) {
  return http.get(`${Harbor}/harborDrapDown`, params)
}
function getHarborPageList(params) {
  params = {
    ...params,
    queryParam: {
      ...params.queryParam,
      sortBy: 1,
      sortField: 'createdOn'
    }
  }
  return http.post(`${Harbor}/getHarborPageList`, params)
}
function insertHarbor(params) {
  return http.post(`${Harbor}/insertHarbor`, params)
}
function updateHarbor(params) {
  return http.post(`${Harbor}/updateHarbor`, params)
}
function deleteHarbor(params) {
  return http.delete(`${Harbor}/deleteHarbor`, params)
}

const transport = '/Transport'
function transportDrapDown(params) {
  return http.get(`${transport}/transportDrapDown`, params)
}
function insertTransport(params) {
  return http.post(`${transport}/insertTransport`, params)
}
function updateTransport(params) {
  return http.post(`${transport}/updateTransport`, params)
}
function deleteTransport(params) {
  return http.delete(`${transport}/deleteTransport`, params)
}

function getTransportPageList(params) {
  params = {
    ...params,
    queryParam: {
      ...params.queryParam,
      sortBy: 1,
      sortField: 'createdOn'
    }
  }
  return http.post(`${transport}/getTransportPageList`, params)
}

const VesselName = '/VesselName'
function addVesselName(params) {
  return http.post(`${VesselName}/addVesselName?vesselName=${params.vesselName}`, params)
}
function getVesselNameList(params) {
  return http.get(`${VesselName}/getVesselNameList`, params)
}
// function getTaxProductPage(params) {
//   return http.post(`${Tax}/getTaxProductPage`, params)
// }

// function getTaxRatePage(params) {
//   return http.post(`${Tax}/getTaxRatePage`, params)
// }

// function saveTaxProduct(params) {
//   return http.post(`${Tax}/saveTaxProduct`, params)
// }

// function saveTaxRate(params) {
//   return http.post(`${Tax}/saveTaxRate`, params)
// }
export {
    getAddressDropdown,
    getScinPageList,
    getAddressFill,
    getAddressBookDrapdown,
    getTaxRatePage,
    saveTaxRate,
    getTaxProductPage,
    saveTaxProduct,
    deleteTaxRate,
    deleteTaxProduct,
    copyPrivateProductToPublic,
    getTaxRateList,
    catchContainerEvents,
    eFreightContainerEvents,
    AMSQuery,
    isfEvents,
    trackEvents,
    defaultAddressBook,
    deleteAddressBook,
    deleteScin,
    getImporterPages,
    addressBookCompanyList,
    distributeAddressBook,
    updateImporterAdvance,
    uploadImporterFile,
    getImporterFiles,
    openSearchAddressBooks,
    openDeleteAddressBook,
    harborDrapDown,
    saveScin,
    transportDrapDown,
    manualRefreshContainerEvents,
    getHarborPageList,
    insertHarbor,
    updateHarbor,
    insertTransport,
    updateTransport,
    getTransportPageList,
    addVesselName,
    getVesselNameList,
    deleteHarbor,
    abiquery,
    deleteTransport,
    saveImportTaxProduct,
    searchUSHts,
    tagTaxProduct,
    confirmTaxProduct,
    getAddressBookPages,
    saveAddressBook,
    getScinList,
    iTraceTerminal,
    reSubscribeClearanceTrack
}
